// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__J4uKg","pointer":"Card_pointer__y4qHo","bgWhite":"Card_bgWhite__gtKbx","small":"Card_small__9XvFF"};